module.exports = __webpack_public_path__ + "tyre.jpg?124522d3b18057b22911680174e65f33";